// extracted by mini-css-extract-plugin
module.exports = {"dp-button-reset":"dp-button-reset___15aJJ"};